import { IDmLoaiLopTinChi } from "../../../model/respone/category/IDmLoaiLopTinChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmLoaiLopTinChiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: [] as IDmLoaiLopTinChi[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: undefined as IDmLoaiLopTinChi | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IDmLoaiLopTinChi,
  SAVE_SUCCESS: undefined as void | undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined as void | undefined,
  DELETE_ERRR: "",
};

export const eDmLoaiLopTinChiActionIds = generateActionTypeIds(
  eDmLoaiLopTinChiActionsObj,
  "DM_LOAI_LOP_TIN_CHI"
);

export type IDmLoaiLopTinChiActionTypes = IGenericActionType<
  typeof eDmLoaiLopTinChiActionsObj,
  "DM_LOAI_LOP_TIN_CHI"
>;

